import { includes, find, get } from 'lodash';

export const isLoading = (state) => get(state, 'calendar.isLoadingCalendar', false);

export const hasLoaded = (state, clubId, year, month) => {
  const id = [clubId, year, month].join('-');
  return includes(get(state, 'calendar.loadedCalendarIds', []), id);
};

const filterCalendarByEventType = (calendar, eventType) => ({
  ...calendar,
  days: [...calendar.days].map((day) => ({
    ...day,
    clubEvents: eventType === 'events' ? day.clubEvents : [],
    fixtures: eventType === 'fixtures' ? day.fixtures : [],
    trainingSessions: eventType === 'training' ? day.trainingSessions : [],
  })),
});

const filterCalendarByTeam = (calendar, teamId) => ({
  ...calendar,
  days: [...calendar.days].map((day) => ({
    ...day,
    clubEvents: [],
    fixtures: day.fixtures.filter((fixture) => fixture.teamId === teamId),
    trainingSessions: day.trainingSessions.filter(({ teamIds }) => includes(teamIds, teamId)),
  })),
});

export const getCalendar = (state, clubId, year, month, teamId, eventType) => {
  const id = [clubId, year, month].join('-');
  let calendar = get(state, `calendar.currentlyLoaded[${id}]`);
  if (!calendar) {
    return null;
  }

  if (eventType) {
    calendar = filterCalendarByEventType(calendar, eventType);
  }

  if (teamId) {
    calendar = filterCalendarByTeam(calendar, teamId);
  }
  return calendar;
};

export const getLoadingError = (state) => get(state, 'calendar.loadingError');

export const isTrainingSessionLoading = (state, id) =>
  includes(get(state, 'calendar.loadingTrainingSessions'), id);

export const hasTrainingSessionLoaded = (state, id) =>
  includes(get(state, 'calendar.loadedTrainingSessions'), id);

export const getTrainingSession = (state, id) =>
  find(get(state, 'calendar.trainingSessions'), { id });

export const getTrainingSessionLoadingError = (state, id) =>
  get(state, `calendar.trainingLoadingErrors[${id}]`);

export const isTrainingAvailabilityLoading = (state, id) =>
  includes(get(state, 'calendar.loadingTrainingAvailabilities'), id);

export const hasTrainingAvailabilityLoaded = (state, id) =>
  includes(get(state, 'calendar.loadedTrainingAvailabilities'), id);

export const getTrainingAvailability = (state, id) => {
  const session = find(get(state, 'calendar.trainingAvailabilities'), { id });
  return get(session, 'memberAvailabilities', []);
};

export const getTrainingAvailabilityLoadingError = (state, id) =>
  get(state, `calendar.trainingLoadingErrors[${id}]`);
